import instance from "../ApiConfig";
import { ApiEndPoints } from "../ApiEndPoints";

export const createMultipleRooms = async (data: object) => {
  try {
    const result = await instance({
      url: ApiEndPoints.CREATE_MULTIPLE_ROOMS,
      method: "POST",
      data,
    });
    // return result;
    return result.data;
  } catch (error) {
    throw error;
  }
};
export const createSingleRooms = async (data: object) => {
  try {
    const result = await instance({
      url: ApiEndPoints.ROOMS_RESOURCE_ROUTE,
      method: "POST",
      data,
    });
    // return result;
    return result.data;
  } catch (error) {
    throw error;
  }
};



export const updateRoomDetail = async (data: object, roomId: number) => {
  try {
    const result = await instance({
      url: ApiEndPoints.ROOMS_RESOURCE_ROUTE + `/${roomId}`,
      method: "PUT",
      data,
    });
    // return result;
    return result.data;
  } catch (error) {
    throw error;
  }
};

export const fetchRoomsList = async (pageNo, itemsPerPage) => {
  try {
    const result = await instance({
      url:
        ApiEndPoints.ROOMS_RESOURCE_ROUTE +
        `?page_no=${pageNo}&items_per_page=${itemsPerPage}`,
      method: "GET",
    });
    // return result;
    return result.data;
  } catch (error) {
    throw error;
  }
};

export const fetchRoomDetail = async (roomId) => {
  try {
    const result = await instance({
      url: ApiEndPoints.ROOMS_RESOURCE_ROUTE + `/${roomId}`,
      method: "GET",
    });
    // return result;
    return result.data;
  } catch (error) {
    throw error;
  }
};

export const fetchAvailableRoomsByCat = async (catId) => {
  try {
    const result = await instance({
      url: ApiEndPoints.AVAILABLE_ROOM_BY_CAT + `/${catId}`,
      method: "GET",
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

export const fetchAvailableRoomsByCatAndRoom = async (catId, roomId, checkIn, checkOut) => {
  try {
    const result = await instance({
      url: ApiEndPoints.AVAILABLE_ROOM_BY_CAT_AND_ROOM + `/${catId}` + `?start_date=${checkIn}&end_date=${checkOut}&existing_room=${roomId}`,
      method: "GET",
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

export const deleteRoomApiCall = async (roomId) => {
  try {
    const result = await instance({
      url: ApiEndPoints.ROOMS_RESOURCE_ROUTE + `/${roomId}`,
      method: "DELETE",
    });
    // return result;
    return result.data;
  } catch (error) {
    throw error;
  }
};
